import { z } from "zod";
import { MetaSchema } from "./shared";

export const userSchema = z.object({
  id: z.string().uuid(),
  uuid: z.string(),
  isActivePlan: z.boolean(),
  isActive: z.boolean(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  gender: z.string().nullable(),
  role: z.string(),
  rank: z.string().nullable(),
  username: z.string().nullable(),
  email: z.string().nullable(),
  avatar: z.string().nullable(),
  activatedPlanAt: z.string().nullable(),
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
});

export const transferTransactionSchema = z.object({
  id: z.string().uuid(),
  transaction_type: z.string(),
  coin: z.string(),
  type: z.string().nullable(),
  value: z.string(),
  amount: z.string(),
  fee: z.string(),
  tracerKey: z.string().nullable(),
  useGGold: z.boolean().nullable(),
  useProfit: z.boolean().nullable(),
  hash: z.string().nullable(),
  created_at: z.string(),
  completedAt: z.string().nullable(),
  status: z.string(),
  description: z.string().nullable(),
  user: userSchema,
  transferTo: userSchema.nullable(),
});

export const getUsersTransferHistorySchema = z.object({
  data: z.tuple([
    z.array(transferTransactionSchema),
    z.number(),
  ]),
  meta: MetaSchema.default,
});

export type GetUsersTransferHistoryResponse = z.infer<
  typeof getUsersTransferHistorySchema
>;
export type TransferTransaction = z.infer<typeof transferTransactionSchema>;
export type User = z.infer<typeof userSchema>;
